const ja = {
  100000001:'重要な情報',
  100000002:'トークン名',
  100000003:'コピー作成者',
  100000004:'コピーの作成時間',
  100000005:'基本情報',
  100000006:'所属パブリックチェーン/プロトコル',
  100000007:'スマートコントラクトアドレス',
  100000008:'公開時間',
  100000009:'発行の総量',
  100000010:'流通の総量',
  100000011:'市場価格',
  100000012:'紹介',
  100000013:'ソーシャルメディア情報',
  100000014:'公式サイト',
  100000015:'ホワイトペーパー',
  100000016:'ブロックチェーンエクスプローラー',
  100000017:'プロジェクト評価',
  100000018:'ランキング',
  100000019:'上位',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'更新時間',
  100000027:'セキュリティスコア',
  100000028:'コントラクトセキュリティスコア',
  100000029:'リスクプロジェクトの統計',
  100000030:'契約コードの詳細',
  100000031:'購入税',
  100000032:'売上税',
  100000033:'ハニーポットかどうか',
  100000034:'再ミント可能かどうか',
  100000035:'ブラックリストがありますか',
  100000036:'ホワイトリストがありますか',
  100000037:'反クジラかどうか',
  100000038:'税率を変更できるか',
  100000039:'オープンソースかどうか',
  100000040:'隠れた保有者がいるかどうか',
  100000041:'自壊可能かどうか',
  100000042:'プロキシ契約かどうか',
  100000043:'残高を変更できますか',
  100000044:'外部呼び出しを実行できますか',
  100000045:'所有権を再取得できますか',
  100000046:'取引のクーリングオフ期間はありますか',
  100000047:' 送金を一時停止できますか',
  100000048:'所有権が放棄されていない',
  100000049:'調整可能なアンチホエールですか',
  100000050:'小数点以下の桁数が多すぎる',
  100000051:'公開されているミントとバーンの方法',
  100000052:'トークンを燃焼すると総量が更新されますか',
  100000053:'トークンを燃焼すると残高が更新されますか',
  100000054:'自己送金で残高が増加しますか',
  100000055:'残高より多くのトークンを送ると無効になりますか',
  100000056:'残高が送金中に更新されていない',
  100000057:'受取人の残高が消耗されますか',
  100000058:'TransferFromを呼び出すと残高を超えた場合に失敗しますか',
  100000059:'BurnFromメソッドは総量を更新しますか',
  100000060:'トークンの購入税を検出します5%以上は高税率と見なされます',
  100000061:'トークンの売却税を検出します5%以上は高税率と見なされます',
  100000062:'トークンがハニーポット詐欺であるか確認します',
  100000063:'さらにトークンを発行できるか確認します',
  100000064:'トークンにユーザーがトークンをスワップまたは転送することを制限できるブラックリストがあるか確認します',
  100000065:'制限を回避できるアドレスを許可するホワイトリストがトークンにあるか確認します',
  100000066:'トークンに反クジラメカニズムがあるか確認します',
  100000067:'トークンに税がありその税が特権を持つ役割によって変更可能かどうか確認します',
  100000068:'トークンがブロックチェーンエクスプローラーで検証されているか確認します',
  100000069:'所有権が放棄されたように見えても契約を操作できる隠れた所有者があるか確認します',
  100000070:'トークンが自己破壊可能か確認します',
  100000071:'トークンが実装契約に関数呼び出しを委任するプロキシ契約であるか確認します',
  100000072:'トークン残高が特権を持つ役割によって変更可能か確認します',
  100000073:'トークンが外部契約を呼び出すか確認します',
  100000074:'トークンに所有権を取り戻すためのバックドアがあるか確認します',
  100000075:'トークンに転送クールダウンメカニズムがあるか確認します',
  100000076:'特権を持つ役割によってトークン取引が一時停止可能か確認します',
  100000077:'所有者の特権が放棄されているか確認します',
  100000078:'トークンの反クジラメカニズムが特権を持つ役割によって変更可能か確認します',
  100000079:'decimals() 関数の戻り値が5以上か確認します',
  100000080:'ランダムなユーザーが mint() および burn() 関数を呼び出すとリバートするか確認します',
  100000081:'burn() 関数を呼び出すと totalSupply が正しく更新されるか確認します',
  100000082:"burnFrom() 関数を呼び出すと許可が正しく更新されるか確認します",
  100000083:'トランザクション送信者と同じ受信者で transfer() 関数を呼び出すと送信者の残高が増えるか確認します',
  100000084:'残高を超える金額で transfer() 関数を呼び出すと失敗するか確認します',
  100000085:"transferFrom() 関数を呼び出した後に支出者の許可が適切に更新されるか確認します",
  100000086:"transferFrom() 関数を呼び出すと支出者の残高が使用されるか確認します",
  100000087:"transferFrom()を呼び出した後に許可額が正しく更新されるか、または金額が無効な場合にトランザクションがリバートされるか確認してください。",
  100000088:"burnFrom()関数を呼び出すことでtotalSupplyが正しく更新されるか確認してください",
  100000089:'鋳造権が存在するか確認します',
  100000090:'凍結権が存在するか確認します',
  100000091:'メタデータが変更可能かどうか確認します',
  100000092:'クリティカル',
  100000093:'メジャー',
  100000094:'ミディアム',
  100000095:'マイナー',
  100000096:'インフォメーショナル',
  100000097:' Mint権限は放棄されましたか',
  100000098:' 凍結権限は放棄されましたか',
  100000099:' トークンのメタデータを変更できますか',

  100000100:'あなたの年次報告書が生成中です…',
  100000101:'ようこそ',
  100000102:'あなたの2024年の振り返り',
  100000103:'私はあなたの個人的なガイドです。',
  100000104:'2024年の足跡を一緒に振り返りましょう。',
  100000105:'レポートを開く',
  100000106:'{num}日前、運命の歯車が回り始めた',
  100000107:'{userName} ここから始まる僕らの物語',
  100000108:'共通の夢のために、私たちは走り続けます',
  100000109:'投資利益スター',
  100000110:'年間総覧ウォレット累積収益率',
  100000111:'あなたは <em class="normal bold" style="color: #2AFF0A;">{percentage}</em> のユーザーよりも先を行っています',
  100000112:'過去1年間、インスクリプションによる <em class="normal bold" style="color: #FFF;">FOMO</em>を経験し、<em class="normal bold" style="color: #FFF;">meme の急騰</em> の喜びを楽しみました。さあ、あなたの思い出の中へ一緒に入っていきましょう。',
  100000113:'エーストレーダー',
  100000114:'2024年度の累計取引（回）',
  100000115:'累積取引額($)',
  100000116:'あなたは <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> のユーザーを超えました。',
  100000117:'これは単なる数字の累積ではなく、あなたの洞察力と知恵のバッジです。',
  100000118:'すべての取引はWeb3.0への推進力です。',
  100000119:'ポテンシャルスター',
  100000120:'ビットコインは2024年に最大<em class="normal">34%</em>の下落を記録し、市場調整が常態化しています。あなたの投資パフォーマンスは単なる一時的な結果であり、未来はまだ可能性に満ちています！',
  100000121:'安定した投資家',
  100000122:'すべての観察と待機は、より正確な瞬間を迎えるためのものです。2025年にはあなたの投資と利益の奇跡を見ることを楽しみにしています。',
  100000123:'2024年に最も取引されたトークンです。',
  100000124:'忘れずに考え続ければ、必ず応答がある',
  100000125:'集中と努力が取引成果に輝いています。',
  100000126:'2024年 Bitcoin の SuperEx における変動幅',
  100000127:'2024年のあなたの Bitcoin の変動率',
  100000128:'おめでとうございます！あなたの資産が増加しました！来年も頑張ろう。',
  100000129:'2024年にビットコインを保有していません。',
  100000130:'卓越な投資家',
  100000131:'安定した投資家',
  100000132:'学習型投資家',
  100000133:'あなたの現物メインボード取引データ',
  100000134:'累計収益($)',
  100000135:'年利率 (%)',
  100000136:'収益リード (%)',
  100000137:'あなたの契約取引データ',
  100000138:'あなたの投資戦略における知恵を示しました。私たちと一緒に旅を選んでくれてありがとうございます！',
  100000139:'帆を張る · 再出発する',
  100000140:'あなたは流行を追うだけでなく、流行の先駆者です！あなたはフリースペースでコインを <em class="normal bold" style="color: #FFF;">{num1}</em> 回発行し、<em class="normal bold" style="color: #FFF;">{num2}</em> 回取引しました。革新的な製品を好むあなたこそ、本当の冒険者です！',
  100000141:'スーパーソーシャル达人',
  100000142:'ご提案いただき、 <em class="normal bold" style="color: #FFF;">{num}</em> 名の新しい顔を迎え入れてくれてありがとうございます。あなたの推薦のおかげで、プラットフォームは繁栄しており、Web3.0への道のりで、より多くの志を同じくする友人が増えることを期待しています。',
  100000143:'ソーシャルポテンシャルの新星',
  100000144:'<em class="normal bold" style="color: #FFF;">{num}</em> のSuperExユーザーが友達を招待して最大40％の取引手数料を稼いでいます。2024年を逃しましたが、2025年にはチャンスをつかんでください。',
  100000145:'あなたの年次の素晴らしい瞬間を共有してください！あなたのコミュニティに共有して、より多くの人々が私たちに参加し、特別な報酬を一緒に解除し、暗号の世界を探索することを奨励してください！',
  100000146:'友達を招待して 10 USDT 相当の報酬を獲得しましょう!',
  100000147:'レポートを共有',
  100000148:'もう一度見る',
  100000149:'2024年、あなたはSuperexで呼ばれます。',
  100000150:'プラットフォームユーザーを超えました:',
  100000151:'現物メインボード 年率収益',
  100000152:'契約 年率収益',
  100000153:'今年、私は投資の伝説です！',
  100000154:'招待コード: {InviteCode}',
  100000155:'SuperEx.com - web3.0 暗号通貨取引所',
  100000156:'安定の中で勝利を求め、 実力を発揮しよう！',
  100000157:'今年は経験を積み、来年はさらに素晴らしい！',
  100000158:'知っていますか？',
  100000159:'SuperExの現物自由区は世界で最も人気があり、最も可能性のあるMemeコイン取引プラットフォームです。',
  100000160:'2024, SuperExに新しい <em class="normal bold" style="color: #FFF;">{num}</em> ユーザーが追加されます, 新しい家族として',
  100000161:'あなたの2024年の振り返りと2025年の千倍の利益の旅が始まります。',
  100000162:'これは Superex の長い家族から送られた手紙で、2024 年の良い知らせが記録されています。',
  100000163:'@to*** は1 USDTで1 BTCを成功裏に購入し、収益率は <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em> に達しました。',
  100000164:'@1o*** が1USDTで1枚のETHを得て、収益率は <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em> に達しました。',
  100000165:'@we*** 1USDTでiPhone15を手に入れ、利回りは <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em> に達します。',
  100000166:'もっと素晴らしいことがあります…',
  100000167:'小資金、大回報、常に進化するプレイスタイルが、参加のたびに驚きをもたらします！',
  100000168:'現物, 契約, 資産運用…',
  100000169:'手紙は長いので、続けて読みましょう',
  100000170:'累計初回発行トークン <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span>、SuperEx は今後もユーザーの皆様により多くの機会を提供できるよう努めてまいります。',
  100000171:'年間ウォレット概覧アカウント累積利益率',
  100000172:'ウォレットの概要 アカウント 年間損益額 <em class="normal bold {classNum}">{num}</em>',
  100000173:'あなたは <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> のユーザーよりも先行しています。あなたの投資戦略の知恵は素晴らしいです。',
  100000174:'2025-SuperEx',
  100000175:'富の道',
  100000176:'準備好之後開啟',
  100000177:'こんにちは！私はSuperEx の新しい友達です。',
  100000178:'SuperExに参加して無限の可能性を探求してください。登録して新しいユーザー特典を受け取ります。',
  100000179:'ユーザー @vb*** が現物メインボード区の取引に参加し、$ATOMの累積収益率は約 <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em> です。',
  100000180:'ユーザー @xi*** 現物メインボードの取引に参加$PIPE累積利益率は約 <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em> に達します。',
  100000181:'ユーザー @09*** は現物メインボード取引$ATHに参加しており、累積収益率は約 <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em> です。',
  100000182:'私たちはWEB3の世界であなたの最初の取引を目撃し、素晴らしい章を始めることを期待しています！',
  100000183:'1USD、スーパースタート、1000+スポット、150倍のレバレッジ、1000倍の銘刻…',
  100000184:'さまざまな高収益セクターを体験してください！',
  100000185:'上下は時に訪れるが、信念は永遠に続く',
  100000186:'波を越えて、価値を目の当たりにする',
  100000187:'2024年の年間レポートはまだ生成されていません。新しい年の取引旅を始め、より多くのインタラクションを蓄積して、次年度の専用サマリーをアンロックしましょう！',
  100000188:'2024 年の仮想通貨年次ストーリーが皆さんのレビューを待っています! SuperEx で 2024 年のハイライトの瞬間を追体験し、特別な瞬間を共有しましょう! ',
  100000189:'2024 年の仮想通貨年次ストーリーが皆さんのレビューを待っています!',
  100000190: 'SuperEx APP を開いて「年次報告書」を表示します',
  100000191: '{year}年{month}月{year}日 (UTC)',
  100000192: '',
  100000193: '',
  100000193: '',
}
export default ja


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/ja.js